import {takeLatest, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchGetUsers(action) {
	try {
		const result = yield fromApi.usersGet(action.token, action.page, action.range, action.filters).then((data) => {
			return data;
		});
		yield put({type: 'GET_USERS_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutUser(action) {
	try {
		const result = yield fromApi.userPut(action.payload, action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_USER_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* watchDeleteUser(action) {
	try {
		const result = yield fromApi.userDelete(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'DELETE_USER_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* users() {
	yield takeLatest('GET_USERS_SAGAS', watchGetUsers);
	yield takeLatest('PUT_USER_SAGAS', watchPutUser);
	yield takeLatest('DELETE_USER_SAGAS', watchDeleteUser);
}

export default function* rootSaga() {
	yield all([users()]);
}
